module.exports = __webpack_public_path__ + "static/media/burger.1d433da6.svg";